import _ from 'lodash'
import { Component } from 'react'

import {
  bindTargetMixin,
  CancelButton,
  SaveButton
} from '../../../../shared/FormBuilder'

import EsasSlideSelect from './EsasSlideSelect'

const valueCheck = (category, rating) => {
  if (!_.isNil(rating) && !category) {
    return 1
  } // no numerical and categorical  numerical and categorical no numerical and no categorical
  if (
    (_.isNil(rating) && category) ||
    (!_.isNil(rating) && category) ||
    (_.isNil(rating) && !category)
  ) {
    return 0
  }
  return null
}

const changeValuesToNumbers = values => {
  const keys = Object.keys(values)
  const newValues = {}
  keys.forEach(key => {
    if (isNaN(values[key])) {
      newValues[key] = values[key]
    } else {
      newValues[key] = _.toNumber(values[key])
    }
  })
  return newValues
}

class EsasForm extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.state = {
      disable: true,
      disableButton: true,
      value: { ...props.initialValues }
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      this.disableButton()
    }
  }

  handleSubmit = () => {
    this.props.onSubmit(changeValuesToNumbers(this.getValue()))
  }

  disableButton = () => {
    const {
      painCategory,
      painRating,
      nauseaCategory,
      nauseaRating,
      dyspneaCategory,
      dyspneaRating,
      anxietyCategory,
      anxietyRating,
      depressionCategory,
      depressionRating,
      drowsinessCategory,
      drowsinessRating,
      appetiteCategory,
      appetiteRating,
      tirednessCategory,
      tirednessRating,
      wellbeingCategory,
      wellbeingRating,
      constipationCategory,
      constipationRating,
      diarrheaCategory,
      diarrheaRating,
      vomitingCategory,
      vomitingRating
    } = this.state.value

    if (!this.state.value) {
      return
    }

    const pain = valueCheck(painCategory, painRating)
    const nausea = valueCheck(nauseaCategory, nauseaRating)
    const dyspensea = valueCheck(dyspneaCategory, dyspneaRating)
    const anxiety = valueCheck(anxietyCategory, anxietyRating)
    const depression = valueCheck(depressionCategory, depressionRating)
    const drowsiness = valueCheck(drowsinessCategory, drowsinessRating)
    const appetitie = valueCheck(appetiteCategory, appetiteRating)
    const tiredness = valueCheck(tirednessCategory, tirednessRating)
    const wellbeing = valueCheck(wellbeingCategory, wellbeingRating)
    const constipation = valueCheck(constipationCategory, constipationRating)
    const diarrhea = valueCheck(diarrheaCategory, diarrheaRating)
    const vomiting = valueCheck(vomitingCategory, vomitingRating)

    const disableCount =
      pain +
      nausea +
      dyspensea +
      anxiety +
      depression +
      drowsiness +
      appetitie +
      tiredness +
      wellbeing +
      constipation +
      diarrhea +
      vomiting
    const disable = disableCount !== 0
    this.setState({
      disableButton: disable
    })
  }

  render () {
    return (
      <div>
        <EsasSlideSelect
          header='Pain'
          ratingName='painRating'
          categoryName='painCategory'
          ratingState={
            this.state.value ? this.state.value.painRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.painCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Nausea'
          ratingName='nauseaRating'
          categoryName='nauseaCategory'
          ratingState={
            this.state.value ? this.state.value.nauseaRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.nauseaCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Dyspnea'
          ratingName='dyspneaRating'
          categoryName='dyspneaCategory'
          ratingState={
            this.state.value ? this.state.value.dyspneaRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.dyspneaCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Anxiety'
          ratingName='anxietyRating'
          categoryName='anxietyCategory'
          ratingState={
            this.state.value ? this.state.value.anxietyRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.anxietyCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Depression'
          ratingName='depressionRating'
          categoryName='depressionCategory'
          ratingState={
            this.state.value ? this.state.value.depressionRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.depressionCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Drowsiness'
          ratingName='drowsinessRating'
          categoryName='drowsinessCategory'
          ratingState={
            this.state.value ? this.state.value.drowsinessRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.drowsinessCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Appetite'
          ratingName='appetiteRating'
          categoryName='appetiteCategory'
          ratingState={
            this.state.value ? this.state.value.appetiteRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.appetiteCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Tiredness'
          ratingName='tirednessRating'
          categoryName='tirednessCategory'
          ratingState={
            this.state.value ? this.state.value.tirednessRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.tirednessCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Wellbeing'
          ratingName='wellbeingRating'
          categoryName='wellbeingCategory'
          ratingState={
            this.state.value ? this.state.value.wellbeingRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.wellbeingCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Constipation'
          ratingName='constipationRating'
          categoryName='constipationCategory'
          ratingState={
            this.state.value ? this.state.value.constipationRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.constipationCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Diarrhea'
          ratingName='diarrheaRating'
          categoryName='diarrheaCategory'
          ratingState={
            this.state.value ? this.state.value.diarrheaRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.diarrheaCategory : undefined
          }
        />
        <EsasSlideSelect
          header='Vomiting'
          ratingName='vomitingRating'
          categoryName='vomitingCategory'
          ratingState={
            this.state.value ? this.state.value.vomitingRating : undefined
          }
          categoryState={
            this.state.value ? this.state.value.vomitingCategory : undefined
          }
        />
        <div className='col-xs-12 end-xs'>
          <CancelButton
            formKey={this.props.formKey}
            onClick={this.props.cancel}
          />

          <SaveButton
            formKey={this.props.formKey}
            disabled={this.state.disableButton}
            onClick={this.handleSubmit}
          />
        </div>
      </div>
    )
  }
}

export default EsasForm
